import { render, staticRenderFns } from "./servicos.vue?vue&type=template&id=c73e144c"
import script from "./servicos.vue?vue&type=script&lang=js"
export * from "./servicos.vue?vue&type=script&lang=js"
import style0 from "./servicos.vue?vue&type=style&index=0&id=c73e144c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports